const translations = {
  "en": {
    "Bearish": "Bearish",
    "Bullish": "Bullish"
  },
  "zh-tw": {
    "Bearish": "看跌",
    "Bullish": "看漲"
  }
};

export default translations;
